import React, { useEffect } from 'react';
import { useRecommendedItems } from 'api/guest_sdk';
import { Spin, Typography } from 'ui-kit';
import { currencyToSymbol, formatCurrency } from 'utils';
import { isPreorderProductV2, isRequestV2, isExternalLinkV2 } from 'utils/product';
import './RecommendedItems.scss';

import ProductCardStore from 'components/Store/ProductCardStore';
import { EPriceType } from 'components/NewProductStepper/ProductBaseForm/constants';

interface Props {
  orderId: number;
  storeCurrency: string;
  handleSetModalItem: (id) => void;
  cartItems: any;
}

const RecommendedItems = ({ orderId, storeCurrency, handleSetModalItem, cartItems }: Props) => {
  const { data: items, isLoading, mutate } = useRecommendedItems({ orderId });

  useEffect(() => {
    mutate();
  }, [cartItems?.length]);

  if (!items?.length) {
    return null;
  }

  return (
    <Spin spinning={isLoading}>
      <div className="RecommendedItems">
        <Typography className="RecommendedItems-title" variant="body2">
          Recommended for you
        </Typography>
        <div className="RecommendedItems-list">
          {items.map((item) => (
            <ProductCardStore
              key={item.id}
              title={item.product_name}
              category={item.category}
              hasQuantity={item.has_quantity}
              price={
                item.price_type === EPriceType.MULTIPLE && item.product_prices.length > 0
                  ? formatCurrency(item.product_prices[0].price)
                  : formatCurrency(item.price)
              }
              currency={currencyToSymbol(storeCurrency)}
              imgSrc={item.image}
              quantity={item.quantity}
              id={item.id}
              onHandleSetModalId={({ id }) => handleSetModalItem(id)}
              isPreorder={isPreorderProductV2({ category: item.category })}
              isRequest={isRequestV2({ requiresApproval: item.requires_approval })}
              isLink={isExternalLinkV2({ category: item.category })}
              priceType={item.price_type}
            />
          ))}
        </div>
      </div>
    </Spin>
  );
};

export default RecommendedItems;
